import React from "react";
import { certifications } from "../mock";
import { BadgeCheck, ShieldCheck, ArrowUpRight } from "lucide-react";

const Certifications = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container-x">
        <div className="max-w-3xl reveal">
          <span className="tag-chip">Certifications Wall</span>
          <h2 className="section-title mt-4">Certified engineering across every major platform</h2>
          <p className="section-sub mt-5">
            Every architectural decision at V4 Data And AI Solutions is backed by hands-on, certified expertise on the platforms Fortune-500 data teams run on.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 md:grid-cols-3 gap-5">
          {certifications.map((c) => {
            const Wrapper = c.url ? "a" : "div";
            return (
            <Wrapper
              key={c.code}
              {...(c.url ? { href: c.url, target: "_blank", rel: "noreferrer" } : {})}
              className="reveal rounded-2xl border border-slate-200 bg-white overflow-hidden hover-lift group block"
              data-testid={`certification-${c.code.toLowerCase()}-card`}
            >
              {/* badge visual */}
              <div className="relative h-40 flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#F5F7FB] to-white">
                {c.badgeImage ? (
                  <div className="relative w-28 h-28 rounded-2xl bg-white/90 p-3 shadow-lg border border-white overflow-hidden flex items-center justify-center float-slow">
                    <img src={c.badgeImage} alt={c.title} className="h-full w-full object-contain" />
                    <span className="absolute inset-0 rounded-2xl soft-pulse" />
                  </div>
                ) : (
                  <div className="relative w-28 h-28 float-slow">
                    <svg viewBox="0 0 100 100" className="w-full h-full">
                      <defs>
                        <linearGradient id={`g-${c.code}`} x1="0" x2="1" y1="0" y2="1">
                          <stop offset="0" stopColor={c.color} />
                          <stop offset="1" stopColor={c.color} stopOpacity="0.7" />
                        </linearGradient>
                      </defs>
                      <polygon points="50,4 92,27 92,73 50,96 8,73 8,27" fill={`url(#g-${c.code})`} />
                      <polygon points="50,10 87,30 87,70 50,90 13,70 13,30" fill="#ffffff" opacity="0.12" />
                      <text x="50" y="48" textAnchor="middle" fontSize="18" fontWeight="900" fill="#ffffff" letterSpacing="1">{c.icon}</text>
                      <text x="50" y="66" textAnchor="middle" fontSize="10" fontWeight="700" fill="#ffffff" opacity="0.9">CERTIFIED</text>
                    </svg>
                    <span className="absolute inset-0 rounded-full soft-pulse" />
                  </div>
                )}
                <span className="absolute top-3 right-3 text-[9px] uppercase tracking-widest font-bold text-slate-500 bg-white/80 border border-slate-200 px-2 py-0.5 rounded">Verified</span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2">
                  <BadgeCheck size={14} className="text-[#1E56E3]" />
                  <span className="text-[11px] font-bold uppercase tracking-widest text-[#1E56E3]">{c.code}</span>
                </div>
                <h3 className="mt-2 text-[15px] font-bold text-[#0B1B3B] leading-snug">{c.title}</h3>
                <div className="mt-2 flex items-center gap-2 text-xs text-slate-500">
                  <ShieldCheck size={12} className="text-emerald-500" /> Issuer: <span className="font-semibold text-[#0B1B3B]">{c.issuer}</span>
                </div>
                {c.url && (
                  <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#EEF3FF] px-3 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-[#1E56E3] transition-all group-hover:bg-[#1E56E3] group-hover:text-white">
                    Verify credential <ArrowUpRight size={14} />
                  </div>
                )}
              </div>
            </Wrapper>
          )})}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
